import { Component, EventEmitter, Output } from '@angular/core';
import { CfetBaseComponent, CfetPageNamesConstant } from '../../../../cfet-core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-utf-registration-verify-form',
    templateUrl: './utf-registration-verify-form.component.html',
    styleUrls: ['./utf-registration-verify-form.component.scss'],
    standalone: false
})
export class UtfRegistrationVerifyFormComponent extends CfetBaseComponent  {

  constructor(private router: Router) {
    super();
  }

  returnUrl = '';
  url = '';
  openCancelModal = '';
  showCancelModal = false;
  @Output() clearTimeout = new EventEmitter<any>(false);



  newSignup (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.clearTimeout.emit(true);
      this.router.navigate([CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION_UTF]);
    }
  }

  attSignin (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.clearTimeout.emit(true);
      window.location.href = environment.att_auth_domain + CfetPageNamesConstant.UTF_SYNC_DETAILS_PAGE;
    }
  }

  cancelModal (event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal (event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }
}
